import { withRouter,useRouteMatch } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import { addToCart, editFromCart, removeFromCart } from "../redux/cartSlice";
import _ from "lodash";
import { calculateKuver, calculateOrderPrice, deleteAlert, exportLogo, getHostName, parsePrice, scaleImage, somethingWentWrong, successMessage } from "../provider/functions";
import { useEffect } from "react";
import { Api } from "../provider/firebase";
import { ProductLoadSuccess } from "../redux";
export default withRouter(CartPage);

const styles = {
  pageContainer: {
    minHeight: '100vh',
    background: 'linear-gradient(180deg, #fafafa 0%, #f0f0f0 100%)',
    paddingBottom: 280,
  },
  header: {
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  backButton: {
    width: 44,
    height: 44,
    borderRadius: 14,
    background: '#fff',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    fontSize: 18,
    color: '#333',
  },
  logoContainer: {
    maxHeight: 56,
    borderRadius: 16,
    overflow: 'hidden',
  },
  logo: {
    height: 56,
    width: 'auto',
    objectFit: 'contain',
  },
  stepsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    padding: '16px 20px 24px',
  },
  step: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  stepNumber: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 13,
    fontWeight: 600,
  },
  stepNumberActive: {
    background: '#000',
    color: '#fff',
  },
  stepNumberInactive: {
    background: 'rgba(0,0,0,0.08)',
    color: 'rgba(0,0,0,0.4)',
  },
  stepName: {
    fontSize: 13,
    fontWeight: 500,
  },
  stepDivider: {
    width: 32,
    height: 2,
    background: 'rgba(0,0,0,0.1)',
    borderRadius: 1,
  },
  cartContainer: {
    padding: '0 16px',
  },
  cartItem: {
    background: '#fff',
    borderRadius: 20,
    padding: 16,
    marginBottom: 12,
    boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
    border: '1px solid rgba(0,0,0,0.04)',
  },
  itemTop: {
    display: 'flex',
    gap: 14,
  },
  itemImage: {
    width: 72,
    height: 72,
    borderRadius: 14,
    objectFit: 'cover',
    background: '#f5f5f5',
    flexShrink: 0,
  },
  itemImagePlaceholder: {
    width: 72,
    height: 72,
    borderRadius: 14,
    background: 'linear-gradient(135deg, #f0f0f0 0%, #e8e8e8 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  itemInfo: {
    flex: 1,
    minWidth: 0,
  },
  itemName: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: 1.3,
    marginBottom: 4,
    display: 'block',
  },
  itemPrice: {
    fontSize: 15,
    fontWeight: 700,
    opacity: 0.9,
  },
  itemOptions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 6,
    marginTop: 8,
  },
  optionTag: {
    fontSize: 11,
    fontWeight: 500,
    padding: '4px 10px',
    borderRadius: 8,
    background: 'rgba(0,0,0,0.05)',
    color: 'rgba(0,0,0,0.65)',
  },
  itemBottom: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 14,
    paddingTop: 14,
    borderTop: '1px solid rgba(0,0,0,0.06)',
  },
  quantityControl: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    background: 'rgba(0,0,0,0.04)',
    borderRadius: 12,
    padding: 4,
  },
  quantityBtn: {
    width: 36,
    height: 36,
    borderRadius: 10,
    border: 'none',
    background: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontSize: 18,
    fontWeight: 500,
    color: '#333',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
  },
  quantityValue: {
    width: 40,
    textAlign: 'center',
    fontSize: 16,
    fontWeight: 600,
    background: 'transparent',
    border: 'none',
  },
  noteInput: {
    width: '100%',
    padding: '10px 14px',
    border: '1px solid rgba(0,0,0,0.08)',
    borderRadius: 12,
    fontSize: 13,
    background: 'rgba(0,0,0,0.02)',
    marginTop: 12,
    outline: 'none',
    color: '#666',
  },
  bottomSheet: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    background: '#fff',
    borderRadius: '24px 24px 0 0',
    padding: '20px 20px 24px',
    boxShadow: '0 -4px 30px rgba(0,0,0,0.1)',
    zIndex: 100,
  },
  priceRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10,
  },
  priceLabel: {
    fontSize: 14,
    color: '#888',
    fontWeight: 500,
  },
  priceValue: {
    fontSize: 14,
    color: '#888',
    fontWeight: 500,
  },
  discountRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10,
    padding: '8px 12px',
    background: 'rgba(229, 57, 53, 0.08)',
    borderRadius: 10,
  },
  discountLabel: {
    fontSize: 14,
    color: '#e53935',
    fontWeight: 600,
  },
  discountValue: {
    fontSize: 14,
    color: '#e53935',
    fontWeight: 700,
  },
  originalPrice: {
    textDecoration: 'line-through',
    opacity: 0.5,
    fontSize: 13,
    marginRight: 6,
  },
  discountedPrice: {
    color: '#e53935',
    fontWeight: 700,
  },
  totalRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: 14,
    borderTop: '1px solid rgba(0,0,0,0.08)',
    marginBottom: 16,
  },
  totalLabel: {
    fontSize: 16,
    fontWeight: 600,
  },
  totalValue: {
    fontSize: 22,
    fontWeight: 700,
  },
  orderButton: {
    width: '100%',
    height: 56,
    borderRadius: 16,
    border: 'none',
    background: '#000',
    fontFamily: 'inherit',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 8px 0 16px',
    outline: 'none',
    transition: 'opacity 0.15s, box-shadow 0.15s',
    gap: 8,
  },
  orderButtonDisabled: {
    opacity: 0.4,
    cursor: 'not-allowed',
  },
  emptyCart: {
    textAlign: 'center',
    padding: '60px 20px',
  },
  emptyIcon: {
    fontSize: 64,
    marginBottom: 16,
    opacity: 0.3,
  },
  emptyText: {
    fontSize: 16,
    color: '#888',
    fontWeight: 500,
  },
};

function CartPage({ history }) {
  const dispatch = useDispatch();
  let match = useRouteMatch();
  const isWebStore = match.params.table=="webstore" || match.params.table=="online";
  const serverReducer = useSelector((state) => state.server.data);
  const {currency,bgcolor1,kuver} = serverReducer;
  const [loading,setloading] = useState(false)
  const language = useSelector((state) => state.language.data);
  const cart = useSelector((state) => state.cart.data);
  const toplam = parseFloat( parseFloat( cart.map(v=>calculateOrderPrice(v)).reduce((a, b) => a + b, 0)).toFixed(2))
  const {freekargo,kargo,min,open,isClosed} = serverReducer.webstore || {open:false,min:0,kargo:0,freekargo:0,isClosed:false}
  const kargoFiyati = parsePrice(isWebStore ? toplam>freekargo ? 0 : kargo : 0);
  const kuverUcreti =( !isWebStore && kuver) ?calculateKuver(kuver,cart) :0;
  
  // İndirim hesaplama
  const toplamIndirim = cart.reduce((acc, item) => {
    const product = item.product;
    if (product.originalPrice && product.originalPrice > product.price) {
      return acc + ((product.originalPrice - product.price) * item.quantity);
    }
    return acc;
  }, 0);
  
  function nextPage(route){
    setloading(true)
    const stokluOlanlar = cart.map((v,k)=>({...v,cartIndex:k})).filter(v=>v.product && v.product.stokluSatis)
    const qts = Object.values(_.groupBy(stokluOlanlar,v=>v.product.id)).map(values=>({...values[0],cartIndex:values.map(v=>v.cartIndex),quantity:values.map(v=>parseInt(v.quantity)).reduce((a,b)=>a+b,0)}))
    if(stokluOlanlar.length>0){
       return Api.post("/stokKontrol",{
        server: match.params.server ? match.params.server : getHostName(),
      }).then(({data})=>{
        var silinenler = [];
        const products = data.products
        var newCart = _.cloneDeep(cart);
        dispatch(ProductLoadSuccess(products.sort((a,b)=>a.rank-b.rank)));
       for (let index = 0; index < qts.length; index++) {
          const element = qts[index];
          const find = products.find(v=>v.id==element.product.id)
          if(!find){
            silinenler.push(element)
            element.cartIndex.map(v=>dispatch(removeFromCart(v)))
            continue;
          }
          const stok = find.stok - element.quantity;
        
          if(stok<0){
            silinenler.push(element)
            element.cartIndex.map(v=>dispatch(editFromCart({
              index:v,
              quantity: parseInt(newCart[v].quantity)+parseInt(stok),
              product:element.product
            })))

          }
        }
        if(silinenler.length>0){
          successMessage(language.product_stokta_yok,language.product_stokta_yok_aciklama+" : "+silinenler.map(v=>v.product.title).join(),"error")
        }else{
          return history.push(route)
        }
      }).catch(err=>{
        somethingWentWrong("Error","stock check error");
      })
      .finally(()=>setloading(false))
     
      return false;
    }
    setloading(false)
     history.push(route)
    
  }
  
  function plus(index,artis=1){
    const newQt = parseInt(cart[index].quantity) + artis;
    if(cart[index].product.stokluSatis && newQt>cart[index].product.stok){
      dispatch(
        editFromCart({
          index,
          quantity: cart[index].product.stok,
        })
      );
      successMessage(language.product_urun_stokta_yok_yada_az,language.product_urun_stokta_yok_yada_az_aciklama+" : "+cart[index].product.stok,"warning")
    }else{
      dispatch(
        editFromCart({
          index,
          quantity: newQt,
        })
      );
    }
  }
  
  function changeNote(index,text){
      dispatch(
        editFromCart({
          index,
          note: text,
        })
      );
  }

  const selectedOptions = (options) => {
    return options.map(v=>v.data ?? []).reduce((a,b)=>a.concat(b),[]).filter((v) => v.checked);
  };

  return (
    <div style={styles.pageContainer}>
      {/* Header */}
      <div style={styles.header}>
        <button style={styles.backButton} onClick={history.goBack}>
          <i className="fa fa-arrow-left" />
        </button>
        <div style={{...styles.logoContainer, background: '#fafafa'}}>
          <img
            style={styles.logo}
            src={serverReducer.image ? serverReducer.image : exportLogo(serverReducer.host)}
            alt="Logo"
          />
        </div>
        <div style={{width: 44}} />
      </div>

      {/* Steps - Modern Progress Bar */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '8px 20px 28px',
        gap: 0,
      }}>
        {/* Step 1 - Menu (Completed) */}
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1}}>
          <div style={{
            width: 36, height: 36, borderRadius: '50%',
            background: 'rgba(76, 175, 80, 0.15)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            marginBottom: 6,
          }}>
            <i className="fa fa-check" style={{color: '#4CAF50', fontSize: 14}}></i>
          </div>
          <span style={{fontSize: 11, fontWeight: 500, color: '#111', opacity: 0.6}}>{language.menu}</span>
        </div>

        {/* Line 1-2 */}
        <div style={{flex: 0.5, height: 3, background: '#4CAF50', borderRadius: 2, marginBottom: 22}}></div>

        {/* Step 2 - Sepet (Active) */}
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1}}>
          <div style={{
            width: 40, height: 40, borderRadius: '50%',
            background:  '#e74c3c',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            marginBottom: 6,
            boxShadow: `0 4px 14px ${'#e74c3c'}40`,
          }}>
            <span style={{color: '#fff', fontSize: 14, fontWeight: 700}}>2</span>
          </div>
          <span style={{fontSize: 11, fontWeight: 600, color: '#111'}}>{language.sepet}</span>
        </div>

        {/* Line 2-3 */}
        <div style={{flex: 0.5, height: 3, background: 'rgba(0,0,0,0.1)', borderRadius: 2, marginBottom: 22}}></div>

        {/* Step 3 - Ödeme (Pending) */}
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1}}>
          <div style={{
            width: 36, height: 36, borderRadius: '50%',
            background: 'rgba(0,0,0,0.06)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            marginBottom: 6,
          }}>
            <span style={{color: 'rgba(0,0,0,0.3)', fontSize: 13, fontWeight: 600}}>3</span>
          </div>
          <span style={{fontSize: 11, fontWeight: 500, color: '#111', opacity: 0.4}}>{language.odeme || "Payment"}</span>
        </div>
      </div>

      {/* Cart Items */}
      <div style={styles.cartContainer}>
        {cart.length === 0 ? (
          <div style={styles.emptyCart}>
            <div style={styles.emptyIcon}>
              <i className="fa fa-shopping-bag"></i>
            </div>
            <p style={styles.emptyText}>{language.sepet_bos || "Sepetiniz boş"}</p>
          </div>
        ) : (
          cart.map(({product,quantity,options,note}, index) => (
            <div style={styles.cartItem} key={index}>
              <div style={styles.itemTop}>
                {product.image ? (
                  <img src={scaleImage(product.image)} alt={product.title} style={styles.itemImage} loading="lazy" />
                ) : (
                  <div style={styles.itemImagePlaceholder}>
                    <i className="fa fa-image" style={{fontSize: 24, opacity: 0.3}}></i>
                  </div>
                )}
                <div style={styles.itemInfo}>
                  <span style={{...styles.itemName, color: '#111'}}>
                    {product.qrTitle || product.title}
                  </span>
                  <div style={{marginTop: 4}}>
                    {product.originalPrice && product.originalPrice > product.price ? (
                      <>
                        <span style={{...styles.originalPrice, color: '#111'}}>
                          {parsePrice(product.originalPrice * quantity)} {currency}
                        </span>
                        <span style={styles.discountedPrice}>
                          {calculateOrderPrice({product,options},quantity)} {currency}
                        </span>
                      </>
                    ) : (
                      <span style={{...styles.itemPrice, color: '#111'}}>
                        {calculateOrderPrice({product,options},quantity)} {currency}
                      </span>
                    )}
                  </div>
                  {selectedOptions(options).length > 0 && (
                    <div style={styles.itemOptions}>
                      {selectedOptions(options).map((o, i) => (
                        <span key={i} style={styles.optionTag}>{o.title}</span>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              
              <div style={styles.itemBottom}>
                <div style={styles.quantityControl}>
                  <button 
                    style={styles.quantityBtn} 
                    onClick={() => plus(index, -1)}
                  >
                    −
                  </button>
                  <input 
                    style={styles.quantityValue}
                    value={quantity} 
                    disabled 
                    type="number" 
                  />
                  <button 
                    style={styles.quantityBtn} 
                    onClick={() => plus(index, 1)}
                  >
                    +
                  </button>
                </div>
              </div>
              
              <input 
                style={styles.noteInput}
                placeholder={language.not_ekle || "Not ekle..."}
                value={note || ''} 
                onChange={e => changeNote(index, e.target.value)} 
              />
            </div>
          ))
        )}
      </div>

      {/* Bottom Sheet */}
      <div style={styles.bottomSheet}>
        {toplamIndirim > 0 && (
          <div style={styles.discountRow}>
            <span style={styles.discountLabel}>
              <i className="fa fa-tag" style={{marginRight: 6}}></i>
              {language.indirim || "İndirim"}
            </span>
            <span style={styles.discountValue}>-{parsePrice(toplamIndirim)} {currency}</span>
          </div>
        )}
        {kuverUcreti > 0 && (
          <div style={styles.priceRow}>
            <span style={styles.priceLabel}>{language.ayarlar_kuver}</span>
            <span style={styles.priceValue}>+{kuverUcreti} {currency}</span>
          </div>
        )}
        {kargoFiyati > 0 && (
          <div style={styles.priceRow}>
            <span style={styles.priceLabel}>{language.teslimat_ucreti}</span>
            <span style={styles.priceValue}>+{kargoFiyati} {currency}</span>
          </div>
        )}
        <button 
          style={{
            ...styles.orderButton,
            background: '#e74c3c',
            boxShadow: `0 6px 28px ${'#e74c3c'}60`,
            ...(cart.length === 0 || loading ? styles.orderButtonDisabled : {})
          }}
          disabled={cart.length === 0 || loading}
          onClick={() => {
            if(toplam < min && isWebStore){
              return somethingWentWrong(language.minimum_tutar_altinda_baslik, language.minimum_tutar_altinda_aciklama.replace("${min}",min).replace("${currency}",currency))
            }else if(isClosed && isWebStore){
              return somethingWentWrong(language.webstore_kapali_baslik, language.webstore_kapali_aciklama)
            }else if(isWebStore || serverReducer.auth){
              return nextPage((match.params.server ? "/" + match.params.server : "") + "/" + match.params.table + "/login/")
            }
            nextPage((match.params.server ? "/" + match.params.server : "") + "/" + match.params.table + "/paycart/")
          }}
        >
          {loading ? "..." : (
            <>
              <div style={{display:'flex',alignItems:'center',gap:8,flexShrink:0}}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <line x1="3" y1="6" x2="21" y2="6" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M16 10a4 4 0 01-8 0" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span style={{fontSize:15,fontWeight:800,letterSpacing:'-0.3px',color:'#fff',whiteSpace:'nowrap'}}>{language.siparis_ver}</span>
              </div>
              <span style={{background:'rgba(255,255,255,0.2)',color:'#fff',borderRadius:10,padding:'7px 14px',fontSize:11,fontWeight:800,letterSpacing:'-0.2px',whiteSpace:'nowrap',lineHeight:1,flexShrink:0}}>
                {parsePrice(toplam + kargoFiyati + kuverUcreti)} {currency}
              </span>
            </>
          )}
        </button>
      </div>

    </div>
  );
}
